import { css } from '@emotion/react';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
// import { Outlet, createRootRouteWithContext, redirect } from '@tanstack/react-router';
import { Authn } from '@frontend/auth';
// import { AuthStorage, localStorageHelper, SsoTenant } from '@frontend/auth-helpers';
import { ShellTitleBar } from '@frontend/shell-theme';
import { TracerModal } from '@frontend/tracer-modal';
import { theme } from '@frontend/theme';
// import { shouldRedirectToSSO } from '../services/route-utils';

const hasShellThemeEnabled =
  window.shell && window.shell?.isShell && window.shell?.featureAvailability?.has('shell-theme');

const styles = {
  container: css`
    display: flex;
    flex: 1;
    justify-content: center;
  `,
  main: css`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    background-color: ${theme.colors.white};
  `,
  innerDiv: css`
    display: flex;
    flex-direction: column;
    height: 100%;
  `,
};

const Root = () => {
  return (
    <>
      <>
        {hasShellThemeEnabled && <ShellTitleBar />}
        <div css={styles.container}>
          <main css={styles.main}>
            <div css={styles.innerDiv}>
              <Outlet />
            </div>
          </main>
        </div>
      </>
      <TracerModal />
    </>
  );
};

// We can get into an infinite redirect loop because loader runs on every route change,
// so guard against that and only redirect once
// let hasRedirectedToSSO = false;

export const Route = createRootRouteWithContext<{ auth: Authn }>()({
  component: Root,
  // NOTE the loader function runs on every route change
  // loader: () => {
  //   const ssoTenant = localStorageHelper.get<SsoTenant>(AuthStorage.sso_tenant);
  //   const isSSOLogin = shouldRedirectToSSO(ssoTenant?.tenant ?? '');

  //   if (isSSOLogin && !hasRedirectedToSSO) {
  //     hasRedirectedToSSO = true;
  //     throw redirect({
  //       to: '/sso/$tenant',
  //       params: {
  //         tenant: ssoTenant?.tenant ?? '',
  //       },
  //     });
  //   }
  // },
  notFoundComponent: () => <div>Not Found</div>,
});
